import { observable } from "aurelia-binding";
import { bindable, bindingMode, customElement } from "aurelia-framework";
import moment from "moment";

import nameof from "../../../common/nameof";
import { PatientMessage } from "../../../models/patient/patient-message";
import { IValidateCustomElement } from "../../../interfaces/i-validate-custom-element";
import { regexLibrary } from "../../../common/utilities/regex-library";

@customElement("add-patient-message-form")
export class AddPatientMessageForm {
    @bindable({ defaultBindingMode: bindingMode.twoWay })
    public patientMessage: PatientMessage;
    @bindable({ defaultBindingMode: bindingMode.toView })
    public isLoading: boolean;
    @bindable({ defaultBindingMode: bindingMode.toView })
    public patientId: string;
    @bindable({ defaultBindingMode: bindingMode.toView })
    public titleTooltip: string;
    @bindable({ defaultBindingMode: bindingMode.oneTime })
    public title: string;
    @observable({
        changeHandler: nameof<AddPatientMessageForm>("messageDateChanged")
    })
    public messageDate: string;
    @observable({
        changeHandler: nameof<AddPatientMessageForm>("messageTimeChanged")
    })
    public messageTime: string;
    public messageDatePickerOptions: DatepickerOptions = {
        endDate: moment().format("MM/DD/YYYY")
    };
    public commentValidation: IValidateCustomElement[] = [
        {
            matches: true,
            satisfies: regexLibrary.preventAsterisk,
            message: "Replace asterisks with individualized patient information."
        }
    ];

    public attached() {
        if (!!this.patientMessage) {
            this.patientMessage.messageTime = moment().format("hh:mm A");
            this.patientMessage.messageDate = moment().format("MM/DD/YYYY");
        }
    }

    public messageDateChanged(newValue: string, oldValue: string) {
        if (!!newValue && newValue !== oldValue) {
            this.patientMessage.messageDate = this.messageDate;
        }
    }

    public messageTimeChanged(newValue: string, oldValue: string) {
        if (!!newValue && newValue !== oldValue) {
            this.patientMessage.messageTime = this.messageTime;
        }
    }
}
